import React from "react";
import { Field, touch, change } from 'redux-form';

import CustomInput from "components/CustomInput/CustomInput.jsx";
import ImageUpload from 'components/CustomUpload/ImageUpload.jsx';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import { campaign_v2Constants } from '../../../constants';
import { normalize } from 'helpers'

import i18n from 'i18n';

import * as FormValidator from '../validate/FormValidator';

function FromPoint({ ...props }) {
    const { dispatch, formMode, rewardImagePreview, rewardImageEngPreview } = props.props
    const { FORM_NAME } = props

    let { readOnly } = props.props

    if (formMode === `add`) {
        readOnly = false
    } else if (formMode === `edit` && !readOnly) {
        readOnly = false
    } else {
        readOnly = true
    }

    return (
        <>
            <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Field
                                name="rewardDetail[setName]"
                                component={CustomInput}
                                type="text"
                                labelText={i18n.t("label.reward_name")}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                disabled={readOnly}
                            />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <Field
                                name="rewardDetail[setNameEN]"
                                component={CustomInput}
                                type="text"
                                labelText={i18n.t("label.reward_name_en")}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                disabled={readOnly}
                            />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <Field
                                name="rewardDetail[description]"
                                component={CustomInput}
                                type="text"
                                labelText={i18n.t("label.reward_description")}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                disabled={readOnly}
                            />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <Field
                                name="rewardDetail[descriptionEN]"
                                component={CustomInput}
                                type="text"
                                labelText={i18n.t("label.reward_description_en")}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                disabled={readOnly}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Field
                                name="rewardPicture"
                                component={ImageUpload}
                                type="text"
                                labelText={i18n.t("label.reward_picture")}
                                textLeft={true}
                                height={190}
                                showRatioGuide={true}
                                onChange={(e) => {
                                    e.preventDefault();
                                    let reader = new FileReader();
                                    let file = e.target.files[0];
                                    reader.onloadend = () => {
                                        dispatch({ type: campaign_v2Constants.SET_FORM_PREVIEW_IMAGE_REWARD, rewardImagePreview: reader.result })
                                    };
                                    try {
                                        if (!FormValidator.validMimeType.includes(file.type)) {
                                            dispatch(touch(FORM_NAME, 'rewardPicture'));
                                        }
                                        reader.readAsDataURL(file);
                                        dispatch(change(FORM_NAME, 'rewardPicture', file))
                                    } catch (error) {
                                        dispatch({ type: campaign_v2Constants.SET_FORM_PREVIEW_IMAGE_REWARD, rewardImagePreview: "default" })
                                        dispatch(change(FORM_NAME, 'rewardPicture', ''))
                                    }
                                }}
                                imagePreviewUrl={rewardImagePreview}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                validate={[FormValidator.validateImageFormat]}
                                disabled={readOnly}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Field
                                name="rewardPictureEN"
                                component={ImageUpload}
                                type="text"
                                labelText={i18n.t("label.reward_picture_en")}
                                textLeft={true}
                                height={190}
                                showRatioGuide={true}
                                onChange={(e) => {
                                    e.preventDefault();
                                    let reader = new FileReader();
                                    let file = e.target.files[0];
                                    reader.onloadend = () => {
                                        dispatch({ type: campaign_v2Constants.SET_FORM_PREVIEW_IMAGE_REWARD_ENG, rewardImageEngPreview: reader.result })
                                    };
                                    try {
                                        if (!FormValidator.validMimeType.includes(file.type)) {
                                            dispatch(touch(FORM_NAME, 'rewardPictureEN'));
                                        }
                                        reader.readAsDataURL(file);
                                        dispatch(change(FORM_NAME, 'rewardPictureEN', file))
                                    } catch (error) {
                                        dispatch({ type: campaign_v2Constants.SET_FORM_PREVIEW_IMAGE_REWARD_ENG, rewardImageEngPreview: "default" })
                                        dispatch(change(FORM_NAME, 'rewardPictureEN', ''))
                                    }
                                }}
                                imagePreviewUrl={rewardImageEngPreview}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                validate={[FormValidator.validateImageFormat]}
                                disabled={readOnly}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Field
                                name="rewardDetail[pointEarn]"
                                component={CustomInput}
                                type="text"
                                labelText={i18n.t("label.reward_point_earn")}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                disabled={readOnly}
                                normalize={normalize.onlyNumber}
                            />
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </>
    );
}

export default FromPoint;
